__turbopack_context__.v({
  "productItem": "CheckoutItemsOverrideMenuConflictList-module-scss-module__s-f27a__productItem",
  "productList": "CheckoutItemsOverrideMenuConflictList-module-scss-module__s-f27a__productList",
  "unavailableProductsList": "CheckoutItemsOverrideMenuConflictList-module-scss-module__s-f27a__unavailableProductsList",
  "unavailableProductsTitle": "CheckoutItemsOverrideMenuConflictList-module-scss-module__s-f27a__unavailableProductsTitle",
});
